import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=c54a3902&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=ts&"
export * from "./AboutUs.vue?vue&type=script&lang=ts&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=c54a3902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54a3902",
  null
  
)

export default component.exports